import JSONPointerEvaluateError from "./JSONPointerEvaluateError.mjs";
class JSONPointerKeyError extends JSONPointerEvaluateError {}
export default JSONPointerKeyError;